<div class="modal-container saved-carts-list-modal-container">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h2>{{ 'cart.savedCartList.delete.label' | cxTranslate }}</h2>
      <button class="close" [disabled]="deleteInProgress">
        <mat-icon svgIcon="modal-x-icon" (click)="closeModal()"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <h3>{{ 'cart.savedCartList.delete.header-label' | cxTranslate }}</h3>
      <p>{{ 'cart.savedCartList.delete.info-label' | cxTranslate }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn secondary-btn" (click)="closeModal()">
        {{ 'common.cancel' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn primary-btn"
        [class.disabled]="deleteInProgress"
        [class.rotating]="deleteInProgress"
        [ngClass]="activeLanguage$ | async"
        (click)="onDeleteSavedCart()"
      >
        <ng-container *ngIf="!deleteInProgress">
          {{ 'cart.savedCartList.delete.label' | cxTranslate }}
        </ng-container>
      </button>
    </div>
  </div>
</div>
